import * as React from 'react';

export default class MercuryIcons extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className}  xmlns="http://www.w3.org/2000/svg" id="mercury" width="24" height="24" viewBox="0 0 23 20" fill="none">
            <g clipath="url(#clip0_64_2419)">
            <path d="M1.84 10.5H0.75V15.11H1.84V10.5Z" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M21.24 10.5H20.15V15.11H21.24V10.5Z" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M16.7801 7.13H5.16005C4.61881 7.13 4.18005 7.56877 4.18005 8.11V17.94C4.18005 18.4812 4.61881 18.92 5.16005 18.92H16.7801C17.3213 18.92 17.7601 18.4812 17.7601 17.94V8.11C17.7601 7.56877 17.3213 7.13 16.7801 7.13Z" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M4.18005 7.13L10.2301 13.13C10.4263 13.3224 10.6902 13.4302 10.9651 13.4302C11.2399 13.4302 11.5038 13.3224 11.7001 13.13L17.7601 7.13" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M2.3 13.02H0.75V9.45C0.759156 8.2983 0.995076 7.15968 1.44429 6.09915C1.8935 5.03863 2.54721 4.07697 3.36809 3.26909C4.18897 2.46122 5.16094 1.82294 6.2285 1.39071C7.29605 0.958487 8.4383 0.740772 9.59 0.750001H12.39C13.5425 0.739451 14.6859 0.95619 15.7546 1.38783C16.8233 1.81946 17.7964 2.45753 18.6184 3.26553C19.4403 4.07354 20.0949 5.03564 20.5448 6.09682C20.9946 7.158 21.2309 8.29745 21.24 9.45V13.02H19.76" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10"/>
            <path d="M21 10C20.3333 12.1667 17.4 16.4 11 16" stroke="#333333"/>
            <rect x="9" y="15" width="4" height="2" fill="white"/>
            </g>
            <defs>
            <clipPath id="clip0_64_2419">
            <rect width="21.99" height="19.67" fill="white"/>
            </clipPath>
            </defs>      
    </svg>
    )
  }
}
